module.exports = __webpack_public_path__ + "assets/img/00063.bcd2de35.png";